import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './WhatIDoSection.css';

const processes = [
    {
        step: "01",
        title: "Analisi & Strategia",
        description: "Analizziamo le tue esigenze e obiettivi per creare una strategia digitale su misura.",
        icon: "fas fa-bullseye"
    },
    {
        step: "02",
        title: "Design & Prototipazione",
        description: "Creiamo wireframe e prototipi interattivi per visualizzare la soluzione finale.",
        icon: "fas fa-pen-ruler"
    },
    {
        step: "03",
        title: "Sviluppo & Implementazione",
        description: "Sviluppiamo il prodotto utilizzando le tecnologie più adatte al tuo progetto.",
        icon: "fas fa-code"
    },
    {
        step: "04",
        title: "Testing & Ottimizzazione",
        description: "Testiamo accuratamente il prodotto e lo ottimizziamo per performance e usabilità.",
        icon: "fas fa-screwdriver-wrench"
    },
    {
        step: "05",
        title: "Deploy & Manutenzione",
        description: "Pubblichiamo il progetto e forniamo supporto continuo per mantenerlo aggiornato.",
        icon: "fas fa-rocket"
    }
];

const technologies = [
    { name: 'Odoo ERP', logo: 'fas fa-cubes', category: 'Gestionale' },
    { name: 'Magento', logo: 'fab fa-magento', category: 'E-commerce' },
    { name: 'Proxmox VE', logo: 'fas fa-layer-group', category: 'Virtualizzazione' },
    { name: 'Kubernetes', logo: 'fas fa-dharmachakra', category: 'DevOps' },
    { name: 'Linux', logo: 'fab fa-linux', category: 'Sistemi' },
    { name: 'PostgreSQL', logo: 'fas fa-database', category: 'Database' },
    { name: 'Asterisk', logo: 'fas fa-phone', category: 'VoIP' },
    { name: 'Windows Server', logo: 'fab fa-windows', category: 'Sistemi' }
];

function WhatIDoSection() {
    return (
        <section id="what-i-do" className="what-i-do-section section-padding">
            <Container>
                {/* Processo di Lavoro */}
                <Row>
                    <Col lg={8} className="mx-auto text-center mb-5">
                        <h2 className="section-title">
                            Come <span className="gradient-text">Lavoriamo</span>
                        </h2>
                        <p className="section-subtitle">
                            Il nostro processo strutturato garantisce risultati eccellenti e trasparenza in ogni fase
                        </p>
                    </Col>
                </Row>

                <Row className="process-container">
                    {processes.map((process, index) => (
                        <Col lg={12} key={index} className="mb-4">
                            <div className={`process-item fade-in-up`} style={{animationDelay: `${index * 0.2}s`}}>
                                <div className="process-step">{process.step}</div>
                                <div className="process-content">
                                    <div className="process-icon"><i className={process.icon}></i></div>
                                    <div className="process-text">
                                        <h4 className="process-title">{process.title}</h4>
                                        <p className="process-description">{process.description}</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>

                {/* Tecnologie */}
                <Row className="mt-5 pt-5">
                    <Col lg={8} className="mx-auto text-center mb-5">
                        <h2 className="section-title">
                            Tecnologie che <span className="gradient-text">Utilizziamo</span>
                        </h2>
                        <p className="section-subtitle">
                            Stack tecnologico moderno per creare soluzioni scalabili e performanti
                        </p>
                    </Col>
                </Row>

                <Row>
                    {technologies.map((tech, index) => (
                        <Col lg={3} md={4} sm={6} className="mb-4" key={index}>
                            <Card className={`tech-card text-center fade-in`} style={{animationDelay: `${index * 0.1}s`}}>
                                <Card.Body>
                                    <div className="tech-logo"><i className={tech.logo}></i></div>
                                    <h5 className="tech-name">{tech.name}</h5>
                                    <span className="tech-category">{tech.category}</span>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}

export default WhatIDoSection;